import { render, staticRenderFns } from "./EditIllustration.vue?vue&type=template&id=70638bae&"
import script from "./EditIllustration.vue?vue&type=script&lang=js&"
export * from "./EditIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports